import { Module, MutationTree, GetterTree, ActionTree } from 'vuex';
import { RootState } from '../types';
import { GeneralState } from './types';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';

const initialState: GeneralState = {
    market: getCurrentMarketSpecs(),
    prompted: {
        baggage: [],
        baggageGlobal: false,
    },
    modal: null,
    page: null,
    prevPage: null,
};

const state: GeneralState = {
    ...initialState,
};

const getters: GetterTree<GeneralState, RootState> = {
    getPrompted(state) {
        return state.prompted;
    },
    getMarket(state) {
        return state.market;
    },
    getPage(state) {
        return state.page;
    },
    getPrevPage(state) {
        return state.prevPage;
    },
    getModal(state) {
        return state.modal;
    },
};

const actions: ActionTree<GeneralState, RootState> = {
    setPromptedBaggage({ commit }, payload) {
        commit('setPromptedBaggage', payload);
    },
    setPromptedBaggageGlobal({ commit }, payload) {
        commit('setPromptedBaggageGlobal', payload);
    },
    setMarket({ commit }, payload) {
        commit('setMarket', payload);
    },
    setPage({ commit }, payload) {
        commit('setPage', payload);
    },
    setModal({ commit }, payload) {
        commit('setModal', payload);
    },
};

const mutations: MutationTree<GeneralState> = {
    setPromptedBaggage(state, payload) {
        state.prompted = {
            ...state.prompted,
            baggage: [...state.prompted.baggage, payload],
        };
    },
    setPromptedBaggageGlobal(state, payload) {
        state.prompted = {
            ...state.prompted,
            baggageGlobal: payload,
        };
    },
    setMarket(state, payload) {
        state.market = payload;
    },
    setPage(state, payload) {
        state.prevPage = state.page;
        state.page = payload;
    },
    setModal(state, payload) {
        state.modal = payload;
    },
};

export const general: Module<GeneralState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
